export default __webpack_public_path__ + "static/media/users.b783e98e.svg";